import React from 'react'
import "./franchise.css"
import { useThemeContext } from '../../../../Context/ThemeContext.js';
import { DARKCOLORS, LIGHTCOLORS } from '../../../../Utils/constants.js';
import { useTranslation } from 'react-i18next';
import { Box, Divider } from '@mui/material';
import Monthlyreport from '../../../../assets/Help/monthlyReport.webp'
import Addfranchise from '../../../../assets/Help/addFranchise.webp'

const Franchise = () => {
  const { mode } = useThemeContext();
  const { t } = useTranslation();

  const containerBG = mode === 'dark' ? DARKCOLORS.BackgroundMenu : LIGHTCOLORS.BackgroundMenu;
  const subtitletext = mode === 'dark' ? DARKCOLORS.GreyScale60 : LIGHTCOLORS.GreyScale60;
  // const titletext = mode === 'dark' ? DARKCOLORS. : LIGHTCOLORS.GreyScale10;
  const headingcolor = mode === 'dark' ? DARKCOLORS.HeadingLightBackground : LIGHTCOLORS.HeadingLightBackground;
  const headingcolor2 = mode === 'dark' ? DARKCOLORS.BodyLightBackground : LIGHTCOLORS.BodyLightBackground;


  return (
    <div className='taxes-container sec-1'>
      <Box className="taxes-title-sec">

        <h2 className='tax-title home-title'>{t('help.franchiseManagement')}</h2>
        <p style={{
          color: subtitletext
        }} className='home-subtitle'>{t('help.franchiseManagementsubtileText')}</p>

      </Box>
      <Divider className='divider' style={{ marginTop: '50px', marginBottom: '50px' }} />

      <Box className='number-sec-container'>

        <Box className="list-container manage-list-container">
          <Box className='doc-inventory-title-sec'>

            <p className='number-structure'> {t('help.franchiseOverview1')}  {t('help.franchiseOverview2')}</p>
          </Box>

          <Box className='manage-discription level_2'>
            <p style={{
              color: subtitletext, marginTop: '10px'
            }} className='home-Navi-bar-text'> {t('help.franchiseOverviewpoint1')}  </p>

            <ul className='display-list' >
              <li style={{
                color: subtitletext, marginTop: '10px'
              }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.franchiseOverviewPoint2bold')} </span>  { t('help.franchiseOverviewPoint2text')} </li>
              <li style={{
                color: subtitletext, marginTop: '10px'
              }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{ t('help.franchiseOverviewPoint3bold')} </span>   { t('help.franchiseOverviewPoint3text')} </li>

              <li style={{
                color: subtitletext, marginTop: '10px'
              }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> { t('help.franchiseOverviewPoint4bold')} </span>   { t('help.franchiseOverviewPoint4text')} </li>
              <li style={{
                color: subtitletext, marginTop: '10px'
              }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{ t('help.franchiseOverviewPoint5bold')} </span>    { t('help.franchiseOverviewPoint5text')} </li>
              <li style={{
                color: subtitletext, marginTop: '10px'
              }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> { t('help.franchiseOverviewPoint6bold')} </span>   { t('help.franchiseOverviewPoint6text')} </li>
              <li style={{
                color: subtitletext, marginTop: '10px'
              }} className='home-Navi-bar-text disc'><span className='number-structure' style={{ color: headingcolor2 }}>
                  { t('help.franchiseOverviewPoint7bold')} </span>
                  { t('help.franchiseOverviewPoint7text')} </li>

            </ul>
          </Box>
        </Box>
        <Box className='nav-svg-sec' >
          <img style={{
            backgroundColor: 'white', borderRadius: '5px',
            width: '90%',

            // maxHeight: '500px',
            // marginTop: '12px',
          }} src={Monthlyreport} alt="Machine Card" />

        </Box>
      </Box>
      <Divider className='divider' style={{ marginTop: '50px', marginBottom: '50px' }} />
      <Box className='number-sec-container'>

        <Box sx={{marginBottom:"50px"}} className="list-container manage-list-container">
          <Box className='doc-inventory-title-sec'>

            <p className='number-structure'>  {t('help.addFranchisehelp')}</p>
          </Box>

          <Box className='manage-discription level_2'>
            <p style={{
              color: subtitletext,
               marginTop: '0px'
            }} addFranchisehelpsubtitle='home-Navi-bar-text'> {t('help.addFranchisehelpsubtitle')}</p>
            <li  className='number-structure franchise-description-subtitle franchise-description-subtitles' style={{ color: headingcolor2,marginTop:'0px' }}>{t('help.General')}</li>

            <ul className='display-list' >
              <li style={{
                color: subtitletext, marginTop: '10px'
              }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.Generalsubtext1bold')}</span>   {t('help.Generalsubtext1text')}</li>
              <li style={{
                color: subtitletext, marginTop: '10px'
              }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.Generalsubtext2bold')}</span>  {t('help.Generalsubtext2text')}</li>
              <li style={{
                color: subtitletext, marginTop: '10px'
              }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>  {t('help.Generalsubtext3bold')}</span>   {t('help.Generalsubtext3text')}</li>
            </ul>
            
            <li  className='number-structure franchise-description-subtitle' style={{ color: headingcolor2 }}>{t('help.contactInformation')}</li>
            <ul className='display-list' >
                <li style={{
                  color: subtitletext, marginTop: '10px'
                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>{t('help.contactInformationSubtext1bold')} </span> {t('help.contactInformationSubtext1text')}</li>
                <li style={{
                  color: subtitletext, marginTop: '10px'
                }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.contactInformationSubtext2bold')}</span>    {t('help.contactInformationSubtext2text')}</li>
            </ul>
            <li  className='number-structure franchise-description-subtitle' style={{ color: headingcolor2 }}>{t('help.addressDetails')}</li>
            <ul className='display-list' >
              <li style={{
                color: subtitletext, marginTop: '10px'
              }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.addressDetailsSubtext1bold')} </span>   {t('help.addressDetailsSubtext1text')}</li>
              <li style={{
                color: subtitletext, marginTop: '10px'
              }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>  {t('help.addressDetailsSubtext2bold')}</span>    {t('help.addressDetailsSubtext2text')}</li>

              <li style={{
                color: subtitletext, marginTop: '10px'
              }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}>  {t('help.addressDetailsSubtext3bold')}</span>    {t('help.addressDetailsSubtext3text')}</li>
              <li style={{
                color: subtitletext, marginTop: '10px'
              }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.addressDetailsSubtext4bold')} </span>   {t('help.addressDetailsSubtext4text')}</li>
              <li style={{
                color: subtitletext, marginTop: '10px'
              }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.addressDetailsSubtext5bold')}</span>    {t('help.addressDetailsSubtext5text')}</li>
              <li style={{
                color: subtitletext, marginTop: '10px'
              }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.addressDetailsSubtext6bold')}</span>   {t('help.addressDetailsSubtext6text')}</li>
            </ul>
           
           {/*  */}
           {/*  */}
           {/*  */}
           {/*  */} 
            <li  className='number-structure franchise-description-subtitle' style={{ color: headingcolor2 }}>{t('help.machines')}</li>
            <ul className='display-list' >
              <li style={{
                color: subtitletext, marginTop: '10px'
              }} className='home-Navi-bar-text disc'>{t('help.machinesText')}</li>

            </ul>

            <li  className='number-structure franchise-description-subtitle' style={{ color: headingcolor2 }}>{t('help.agreementDetails')}</li>
            <ul className='display-list' >
              <li style={{
                color: subtitletext, marginTop: '10px'
              }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.agreementDetailspoint1Bold')} </span>  {t('help.agreementDetailspoint1Text')}</li>
              <li style={{
                color: subtitletext, marginTop: '10px'
              }} className='home-Navi-bar-text disc'> <span className='number-structure' style={{ color: headingcolor2 }}> {t('help.agreementDetailspoint2Bold')}</span>   {t('help.agreementDetailspoint2Text')}</li>
            </ul>
            <li  className=' franchise-description-subtitle' style={{ color: subtitletext }}><span className='number-structure' style={{ color: headingcolor2 }}>  {t('help.agreementDetailspoint3Bold')}</span> {t('help.agreementDetailspoint3Text')}</li>
          </Box>
        </Box>
        <Box className='nav-svg-sec' >
          <img style={{
            backgroundColor: 'white', borderRadius: '5px',
            width: '90%',

            // maxHeight: '500px',
            // marginTop: '12px',
          }} src={Addfranchise} alt="Machine Card" />

        </Box>
      </Box>

    </div>
  )
}

export default Franchise